export default __webpack_public_path__ + "static/media/cruz.df9a1bfd.svg";